import React from 'react';

export type TabType = 'base' | 'galaxy' | 'fleet' | 'combat' | 'shipyard' | 'research' | 'alliance' | 'daily' | 'shop';

interface NavigationProps {
  activeTab: TabType;
  onSelectTab: (tab: TabType) => void;
}

export const Navigation: React.FC<NavigationProps> = ({ activeTab, onSelectTab }) => {
  const tabs: { id: TabType; label: string; icon: string }[] = [
    { id: 'base', label: 'CĂN CỨ', icon: '🏛️' },
    { id: 'galaxy', label: 'THIÊN HÀ', icon: '🌌' },
    { id: 'fleet', label: 'HẠM ĐỘI', icon: '🛡️' },
    { id: 'combat', label: 'T.CHIẾN', icon: '⚔️' },
    { id: 'shipyard', label: 'X.TÀU', icon: '🛠️' },
    { id: 'research', label: 'N.CỨU', icon: '🔬' },
    { id: 'alliance', label: 'L.MINH', icon: '🚩' },
    { id: 'daily', label: 'THƯỞNG', icon: '🎁' },
    { id: 'shop', label: 'SHOP', icon: '⭐' },
  ];

  return (
    <nav style={{
      position: 'sticky',
      bottom: 0,
      zIndex: 100,
      background: 'rgba(5, 8, 17, 0.96)',
      backdropFilter: 'blur(10px)',
      borderTop: '1px solid var(--border-panel)',
      display: 'grid',
      gridTemplateColumns: 'repeat(9, 1fr)',
      paddingTop: 4,
      paddingLeft: 2,
      paddingRight: 2,
      paddingBottom: 'calc(4px + env(safe-area-inset-bottom, 0px))',
    }}>
      {tabs.map((t) => {
        const isActive = activeTab === t.id;
        return (
          <button
            key={t.id}
            data-tab={t.id}
            onClick={() => onSelectTab(t.id)}
            style={{
              background: isActive ? 'rgba(0, 229, 255, 0.12)' : 'transparent',
              border: 'none',
              borderTop: isActive ? '2px solid var(--accent-cyan)' : '2px solid transparent',
              color: isActive ? 'var(--accent-cyan)' : 'var(--text-dim)',
              padding: '6px 2px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3,
              cursor: 'pointer',
              fontFamily: 'var(--font-main)',
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: 0.5,
              transition: 'all 0.15s ease',
            }}
          >
            <span style={{ fontSize: 16 }}>{t.icon}</span>
            <span>{t.label}</span>
          </button>
        );
      })}
    </nav>
  );
};
